import React, { useContext, useEffect, useRef, ReactNode } from 'react';
import { TutorialContext } from './InteractiveTutorial';

interface TutorialStepProps {
  id: string;
  children: ReactNode;
  className?: string;
}

const TutorialStep: React.FC<TutorialStepProps> = ({
  id,
  children,
  className = '',
}) => {
  const { currentStepId, registerStep, unregisterStep } =
    useContext(TutorialContext);
  const elementRef = useRef<HTMLDivElement>(null);
  const isActive = currentStepId === id;

  useEffect(() => {
    if (elementRef.current) {
      registerStep(id, elementRef.current);
    }

    return () => {
      unregisterStep(id);
    };
  }, [id, registerStep, unregisterStep]); // Now safe to include since functions are memoized with useCallback

  return (
    <div
      ref={elementRef}
      className={`${className} ${isActive ? 'relative z-[10002]' : ''}`}
      data-tutorial-step={id}
    >
      {children}
    </div>
  );
};

export default TutorialStep;
